import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";
import { FEATURE, PERMISSION, REINSURANCE_DEPT } from "@/lib/permissions";

export default function NotAuthorized() {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();

  const landingRoute = (() => {
    if (hasPermission(REINSURANCE_DEPT, FEATURE.TREATY, PERMISSION.VIEW_TREATIES)) {
      return "/re-insurance/treaty";
    }
    if (hasPermission(REINSURANCE_DEPT, FEATURE.BROKER, PERMISSION.VIEW_BROKERS)) {
      return "/re-insurance/brokers";
    }
    if (hasPermission(REINSURANCE_DEPT, FEATURE.REINSURER, PERMISSION.VIEW_REINSURERS)) {
      return "/re-insurance/reinsurers";
    }
    return null;
  })();

  return (
    <div className="flex h-[70vh] w-full flex-col items-center justify-center text-center px-6">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-muted mb-5">
        <Lock className="h-6 w-6 text-muted-foreground" />
      </div>
      <h1 className="text-xl font-semibold mb-2">Access Restricted</h1>
      <p className="text-sm text-muted-foreground max-w-md mb-6">
        You don’t have permission to access this page. Please contact your
        administrator if you believe this is a mistake.
      </p>
      {landingRoute && (
        <Button onClick={() => navigate(landingRoute)}>Go to Dashboard</Button>
      )}
    </div>
  );
}
